<template>
  <div class="yzm-coupons flex">
    <div class="yzm-coupons__left flex flex-column flex-center flex-item-center">
      <div class="yzm-coupons__left-title flex flex-item-center">￥
        <span class="line-1">{{ item.setting?.value }}</span>
      </div>
      <div>无门槛</div>
    </div>
    <div class="yzm-coupons__center flex-1 flex flex-column flex-center">
      <div class="yzm-coupons__center-title line-1">{{ item.setting.title }}</div>
      <div class="line-1">{{ item.setting.text }}</div>
      <div class="line-1">有效期至{{ item.setting.timeValue }}</div>
    </div>
    <div class="yzm-coupons__right flex flex-center flex-item-center">立即领取</div>
  </div>
</template>
<script setup>
import { defineProps, computed, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-coupons {
  width: 243px;
  height: 72px;
  background-color: #ffffff;
  -webkit-mask: radial-gradient(circle at left center, transparent 5px, #ffffff 5px);
  &__left {
    width: 25%;
    background-color: #25a7fc;
    background: linear-gradient(66.49851696292738deg, #26cfee 0%, #25a7fc 100%);
    font-size: 12px;
    color: #fff;
    position: relative;
    border-radius: 3px 0 0 3px;
    &::after {
      content: '';
      display: block;
      position: absolute;
      right: -2px;
      top: 10%;
      height: 80%;
      border-right: 5px dotted #fff;
    }
  }
  &__left-title {
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    > span {
      font-weight: 600;
      font-size: 18px;
      display: block;
      width: 24px;
    }
  }
  &__right {
    width: 30px;
    background: linear-gradient(66.49851696292738deg, #26cfee 0%, #25a7fc 100%);
    font-size: 11px;
    color: #ffffff;
    writing-mode: vertical-lr;
    letter-spacing: 3px;
    border-radius: 0 3px 3px 0;
    -webkit-mask: radial-gradient(circle at 0px 5px, #0000 5px, red 0);
    -webkit-mask-position: 0px -5px;
  }
  &__center {
    font-size: 10px;
    color: #989daf;
    padding: 0 12px;
    > div {
      width: 140px;
    }
  }
  &__center-title {
    color: #283454;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  }
}
</style>
